<template>
  <div class="r-wrp" :class="{ 'r-wrp--visible': !isLoading }" v-loading="isLoading">
    <vue-recaptcha
      class="r-wrp__inner"
      ref="recaptcha"
      :sitekey="gRecaptchaKey"
      @verify="$emit('verify', $event)"
    ></vue-recaptcha>
  </div>
</template>

<script>
  import VueRecaptcha from 'vue-recaptcha';

  export default {
    data: () => ({
      isLoading: true,
      gRecaptchaKey: '6LdeMXoUAAAAAHaj6OTqsrTp90jC1vsdPJ4P1ItI',
    }),
    methods: {
      reset() {
        this.$refs.recaptcha.reset();
      },
    },
    mounted() {
      setTimeout(() => (this.isLoading = false), 500);
    },
    components: {
      'vue-recaptcha': VueRecaptcha,
    },
  };
</script>

<style scoped lang="scss">
  .r-wrp {
    height: 66px;
    margin-bottom: 24px;
    position: relative;

    &__inner {
      transform-origin: left top;
      transform: scale(0.84) translateX(-2px);
      margin-bottom: 16px;
      //
      transition: opacity 200ms;
      opacity: 0;
    }

    &__spinner {
      width: 100%;
      height: 100%;
      //
      position: absolute;
      top: 0;
      left: 0;
      //
      transition: opacity 200ms;
      opacity: 1;
    }

    &--visible &__spinner {
      opacity: 0;
    }

    &--visible &__inner {
      opacity: 1;
    }
  }
</style>
